<template>
    <div class="usos-container">
        <div v-html="html" @click="to"></div>
    </div>
</template>

<script setup>
import {onMounted, ref} from "vue";

const props = defineProps(['zonaId'])
const emit = defineEmits()

const html = ref('')

const to = async (event) => {
    let sigla = await getSigla(event.target.dataset.id)
    emit('to-sigla', sigla)
}

const getSigla = async (id) => {
    return (await window.axios.get(`/api/viabilidade/siglas/${id}`)).data.data
}

onMounted(async () => {

    let soloUse = (await window.axios.get(`/api/viabilidade/usos-solo/zoneamento/${props.zonaId}`)).data.data
    html.value = soloUse.html
    await (new Promise(resolve => setTimeout(resolve, 1)));
    const elementos = document.querySelectorAll("[data-id]");
    for (const el of elementos) {
        let sigla = await getSigla(el.getAttribute('data-id'));
        el.setAttribute('title', sigla.description);
    }
})
import axios from "axios";
</script>

<style scoped>
.usos-container {
    max-width: 750px;
    margin: 0 auto;
}

@media print {
    .usos-container {
        max-width: none;
    }
}


:deep(a) {
    color: blue !important; /* Cor do texto */
    text-decoration: underline !important; /* Sublinha o texto */
    cursor: pointer !important; /* Altera o cursor para indicar que é interativo */
}

:deep(a:hover) {
    color: darkblue !important; /* Mudança de cor ao passar o mouse */
}

</style>